import { AutenticaService } from './login/autentica.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  mostrarMenu:boolean = false;

  constructor(private autentica:AutenticaService){}

  // trata se vai mostrar o menu ou não (logado/deslogado)
  ngOnInit(){
    this.autentica.mostrarMenuEmitter.subscribe(
      mostrar => {
        this.mostrarMenu = mostrar;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts